/**
 * One layout worker for the preview and the PDF export (part 21: the export takes the pages the preview has settled, B5,
 * so both must ask the same worker). It starts the first time either needs it; terminating it (a preview restart, the
 * app closing) stops it for both, and whichever asks next starts a new one.
 */
import type { LayoutConnection } from './controller.ts';

/** A `connect` that gives the live worker's connection, starting one with `start` when there is none. */
export function sharedWorker(start: () => LayoutConnection): () => LayoutConnection {
  let current: LayoutConnection | null = null;
  return () => {
    if (current !== null) return current;
    const started = start();
    const connection: LayoutConnection = {
      client: started.client,
      terminate: () => {
        // A connection terminated after a newer one started leaves the newer one alone.
        if (current === connection) current = null;
        started.terminate();
      },
    };
    current = connection;
    return connection;
  };
}
